import _ from 'lodash';
import React, {Fragment, useEffect, useState} from "react";
import {NavHashLink, HashLink} from 'react-router-hash-link';
import {useNavigate, useMatch, NavLink, useLocation} from "react-router-dom";
import { useTranslation, initReactI18next } from "react-i18next";
import {push as Menu} from 'react-burger-menu';
import classNames from "classnames";
import useMediaQuery from "../hooks/useMediaQuery";
import {Button} from "./Button";
import {ModalTypes, NarBarBackButtonPrefersLogo, SubchainMainWebsite, SubchainMainWebsiteName} from "../constants";
import leftArrow from "../assets/icons/arrows/left@2x.png";
import brandLogo from "../assets/logos/grovewars_logo_stacked.png";
import tokenIcon from "../assets/logos/grove@2x.png";
import {useDispatch, useSelector} from "react-redux";
import {selectBalances, selectCurrentAccount} from "../store/models/wallet";
import {formatWei, truncate} from "../utils";
import UIState from "../store/uiState";

export const Navbar = ({}) => {
    const { t, i18n } = useTranslation();
    const account = useSelector(selectCurrentAccount);
    const balances = useSelector(selectBalances);
    const dispatch = useDispatch();

    return (
        <div className={'Navbar'}>
            <React.Fragment>
                <div className={'Navbar__content'}>
                    <a className={'NavbarBackButton'}
                       href={'/'}
                    >
                        <img src={leftArrow} className={'NavbarBackButton__arrow'}/>
                        {
                            NarBarBackButtonPrefersLogo &&
                            <img src={brandLogo} className={'NavbarBackButton__logo'}/>
                        }
                        {
                            !NarBarBackButtonPrefersLogo &&
                            <span>{SubchainMainWebsiteName}</span>
                        }
                    </a>
                    <NavLink to={'/'}
                             className={'Navbar__link'}
                    >
                        Builder
                    </NavLink>
                    <NavLink to={'/claim'}
                             className={'Navbar__link'}
                    >
                        Airdrops
                    </NavLink>
                    <div className={'Navbar__right'}>
                        {
                            account &&
                            <Fragment>
                                <a className={'NavbarBalance'}
                                   onClick={() => {
                                        dispatch(UIState.actions.showModal(ModalTypes.GetMoreGrove))
                                   }}
                                >
                                    <div>{formatWei(balances?.groveTokenOnHand) || 0}</div>
                                    <img src={tokenIcon}/>
                                </a>
                                <div className={'NavbarUser'}>
                                    <div className={'NavbarUser__name'}
                                            onClick={() => {
                                                dispatch(UIState.actions.showModal(ModalTypes.Login))
                                            }}
                                    >
                                        <span>{truncate(account)}</span>
                                    </div>
                                    <img src={''}/>
                                </div>
                            </Fragment>
                        }
                        {
                            _.isNil(account) &&
                            <Fragment>
                                <Button color={'red'}
                                        onClick={() => {
                                            dispatch(UIState.actions.showModal(ModalTypes.Login))
                                        }}
                                >
                                    Connect Wallet
                                </Button>
                            </Fragment>
                        }
                    </div>

                </div>
            </React.Fragment>
        </div>
    )
}

export const SimpleNavbar = ({}) => {
    const location = useLocation();

    return (
        <div className={'Navbar'}>
            <React.Fragment>
                <div className={'Navbar__content'}
                     style={{justifyContent: 'center'}}
                >
                    <a className={'NavbarBackButton'}
                       href={'/'}
                    >
                        <img src={leftArrow} className={'NavbarBackButton__arrow'}/>
                        {
                            NarBarBackButtonPrefersLogo &&
                            <img src={brandLogo} className={'NavbarBackButton__logo'}/>
                        }
                        {
                            !NarBarBackButtonPrefersLogo &&
                            <span>{SubchainMainWebsiteName}</span>
                        }
                    </a>
                </div>
            </React.Fragment>
        </div>
    )
}

